import Vue from 'vue'
import VueRouter from 'vue-router'

import LandingPageComponent from '../components/LandingPageComponent.vue'

const ImprintComponent = () =>
  import(/* webpackChunkName: 'imprint-component' */ '../components/ImprintComponent.vue')
const DataPrivacyComponent = () =>
  import(/* webpackChunkName: 'privacy-component' */ '../components/DataPrivacyComponent.vue')
const ErrorComponent = () =>
  import(/* webpackChunkName: 'error-component' */ '../components/ErrorComponent.vue')
const ProductDetailComponent = () =>
  import(/* webpackChunkName: 'product-component' */ '../components/ProductDetailComponent.vue')
const ArtistDetailComponent = () =>
  import(/* webpackChunkName: 'artist-component' */ '../components/artist/ArtistDetailComponent.vue')
const SearchComponent = () =>
  import(/* webpackChunkName: 'search-component' */ '../components/search/SearchComponent.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: LandingPageComponent,
    meta: { title: 'Startseite – Musicline' }
  },
  {
    path: '/search',
    component: SearchComponent,
    props: route => ({ encodedQuery: route.query.q }),
    meta: { title: 'Suche – Musicline' }
  },
  {
    path: '/artist/:artistname/:artistid',
    component: ArtistDetailComponent,
    props: route => ({ encodedQuery: route.query.q }),
    meta: { title: 'Künstler – Musicline' }
  },
  {
    path: '/product/:ean',
    component: ProductDetailComponent,
    props: true,
    meta: { title: 'Produktdetails – Musicline' }
  },
  {
    path: '/imprint',
    component: ImprintComponent,
    meta: { title: 'Impressum – Musicline' }
  },
  {
    path: '/data-privacy',
    component: DataPrivacyComponent,
    meta: { title: 'Datenschutz – Musicline' }
  },
  {
    path: '*',
    component: ErrorComponent,
    meta: { title: 'Seite nicht gefunden – Musicline' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 90 }
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

/**
 * Accessibility: update document title and focus
 */
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Musicline'
  next()
})

router.afterEach(() => {
  Vue.nextTick(() => {
    const main = document.querySelector('main')
    if (main) {
      main.setAttribute('tabindex', '-1') // Make it focusable
      main.focus()
    }
  })
})

export default router
